module.exports = __webpack_public_path__ + "static/media/property-off.cbdeffc2.svg";